/*-----------------------------------------------------------------
- Case Studies route
-----------------------------------------------------------------*/

const prefix = 'case-study';
const routes = [
    {
        path     : `${prefix}`,
        name     : `${prefix}`,
        component: () => import('@/modules/case-studies/views/List.vue'),
    },
    {
        path     : `${prefix}/:slug`,
        name     : `${prefix}-single`,
        component: () => import('@/modules/case-studies/views/Single.vue'),
    },
];

export default routes;
